import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconAssetStoryStyle0 = gravityIconIndividualCss;

const GravityIconAssetStory = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'c7acb6d30c56e86e1e0939ba286533fdb9c319ea', color: this.color, size: this.size }, h("svg", { key: '1f6f2d01fc3f659f04ca404d265bc02a4ce267ab', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '24ce112b4d4bf793e8660bc0aeb1d489783ed92b', d: "M8.5 10.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-3ZM8 7.52a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-.5Zm.5 5.96a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-5Z", fill: "currentColor" }), h("path", { key: 'f1c0d48a384eecf9771fd6d016c2156c6195bc79', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.5 3a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5h-13Zm12 1.5v13h-11v-13h11Z", fill: "currentColor" }))));
    }
};
GravityIconAssetStory.style = GravityIconAssetStoryStyle0;

export { GravityIconAssetStory as gravity_icon_asset_story };

//# sourceMappingURL=gravity-icon-asset-story.entry.js.map